<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="evalTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
         <template slot="score" slot-scope="data">
          <el-rate v-model="data.row.score" disabled></el-rate>
         </template>
         <template slot="evaluaImg" slot-scope="data">
           <img class="table-img" v-if="data.row.evaluaImg && data.row.evaluaImg.length > 0" :src="imgUrl + data.row.evaluaImg.split(',')[0]">
         </template>
         <template slot="goodsName" slot-scope="data">
           <span class="normal-status" style="font-weight: 700;cursor: pointer;" @click="toClickAction(data.row)">{{data.row.goodsName}}</span>
         </template>
         <template slot="evaluation" slot-scope="data">
           <div v-html="data.row.evaluation"></div>
         </template>
       </wt-form-table-list>
    </wt-form-table>
    <wt-detail-page  :visible.sync="goodsVisible" :component-name="goodsComponentName" component-type="view" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_GOODSEVALUATION',
        formComponent: {
          view: { type: 'component', componentName: 'GoodsEvaluation-view', value: 'queryGoodsEvaluationDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/goodsEvaluation/goodsEvaluationList' },
          delete: { type: 'default', value: '/modules/goodsEvaluation/goodsEvaluationDelete' }
        },
        formInputsData: [
          { name: '评价内容', key: 'evaluation', value: '', type: 'text' },
          { name: '搜索用户', key: 'keyWord', value: '', type: 'text' },
          { name: '发布时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '评价内容', key: 'evaluation', type: 'custom' },
          { name: '评价星级', key: 'score', type: 'custom' },
          { name: '昵称', key: 'nickName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '商品名称', key: 'goodsName', type: 'custom' },
          { name: '发布时间', key: 'createTime', type: 'text', sortable: 'custom' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      },
      goodsVisible: false,
      goodsComponentName: 'Goods-view'
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setGoodsEvaluationDetailData', data.row)
        }
      }
    },
    toClickAction(row) {
      this.$store.dispatch('queryGoodsDetailData', row.goodsId)
      this.goodsVisible = true
    }
  }
}
</script>
